import React, { Component } from "react";
import "VENDOR/Footer/footer.css";
import vendorApiCall from "vendorApiCall";
import PurchaseRequestConversation from "./PurchaseRequestConversation";
import PurchaseRequestConversationFooter from "./PurchaseRequestConversationFooter";
import config from "config";
import { connect } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronUp, faTimes } from "@fortawesome/free-solid-svg-icons";
import contact from "../CommonResources/contact.png";
import { faUps } from "@fortawesome/free-brands-svg-icons";
import PopoverWrapper from './PopoverWrapper';

let apiPath = "/vendor/api/vendor.php";

class Footer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      messages: {},
      selectedMessage: null,
      isModalOpen: false,
      clients: {},
      isContactModalOpen: false,
      selectedClientId: null,
      selectedQuotationId: null,
      iidArray: [],
      iidDetails: {},
      prId: null,
      iid: null,
      isPopoverOpen: false,
      userId: null,
      prVendorId: null,
      userName: null,
      instituteName: null,
      clientSearchQuery: "",
      quotationSearchQuery: "",
      selectedClientName:""
    };
    this.iidDetails = JSON.parse(localStorage.getItem("iidDetails"));
  }

  componentDidMount() {
    this.fetchContacts();
    this.fetchNewMessages();
    this.messageInterval = setInterval(() => {
      this.fetchNewMessages();
      this.fetchContacts();

    }, 10000); 
  }
  componentWillUnmount() {
    if (this.messageInterval) {
      clearInterval(this.messageInterval);
    }
  }
  componentDidUpdate(prevProps) {
    if (
      JSON.stringify(this.props.iidArray) != JSON.stringify(prevProps.iidArray) || JSON.stringify(this.props.iidDetails) != JSON.stringify(prevProps.iidDetails)
    ) {
      this.setState(
        {
          iidArray: this.props.iidArray,
          iidDetails: this.props.iidDetails,
        },
        () => {
          this.fetchNewMessages();
          this.fetchContacts();
        }
      );
    }
  }

  fetchMessages = async (prvid) => {
    const requestData = {
      prVendorId: prvid,
      userRole: "vendor",
    };

    try {
      const jsonResponse = await vendorApiCall.makeApiCall(
        "inventory_getPurchaseRequestCommunication",
        requestData,
        apiPath
      );

      const response = jsonResponse?.APIResult || {};

      this.fetchNewMessages();

      if (response.success) {
      } else {
        console.error(
          "Failed to fetch messages:",
          response.message || "Unknown error"
        );
      }
    } catch (error) {
      console.error("Error while fetching messages:", error);
    }
  };

  fetchNewMessages = async () => {
    const vendorArray = Object.keys(this.props.iidDetails).map(iid => {
      const details = this.props.iidDetails[iid]?.details;
      return details?.vendorId || null;
    }).filter(Boolean);

    const requestData = {
      iidArray: this.state.iidArray,
      userRole: "vendor",
      vendorId: config.instructorInfo.data.vendorId,
      vendorIdArray: vendorArray,
    };

    let jsonResponse = await vendorApiCall.makeApiCall(
      "inventory_getNewPurchaseRequestMessage",
      requestData,
      apiPath
    );

    const response = jsonResponse?.APIResult || {};

    if (response.success) {
      this.setState({ messages: response.data });
    }
  };

  fetchContacts = async () => {
    const vendorArray = Object.keys(this.props.iidDetails).map(iid => {
      const details = this.props.iidDetails[iid]?.details;
      return details?.vendorId || null;
    }).filter(Boolean);
    const requestData = {
      vendorId: config.instructorInfo.data.vendorId,
      vendorIdArray: vendorArray,

    };
    let jsonResponse = await vendorApiCall.makeApiCall(
      "vendor_getClientsAcrossAllInstitutes",
      requestData,
      apiPath
    );

    const response = jsonResponse?.APIResult || {};

    if (response.success) {
      this.setState({ clients: response.data });
    }
  };

  handleMessageClick = (message) => {
    this.setState({
      selectedMessage: message,
      isModalOpen: true,
    });
  };

  closeModal = () => {
    this.setState({
      isModalOpen: false,
      selectedMessage: null,
    });
  };

  handleContactClick = () => {
    this.setState({
      isContactModalOpen: true,
    });
  };

  handleFooterContactClick = (clientId, quotationId) => {
    this.setState({
      isContactModalOpen: true,
      selectedClientId: clientId,
      selectedQuotationId: quotationId,
    });
  };

  handleClientClick = (clientId, iid, name) => {
    this.setState({
      selectedClientId: clientId,
      selectedQuotationId: null,
      selectedClientName:name,
      message: "",
      iid: iid,
    });
  };

  handleQuotationClick = (quotationId, quotationNumber, prId) => {
    this.setState({
      selectedQuotationId: quotationId,
      message: quotationNumber,
      prId: prId,
    });
  };
  contactModal() {
    const {
      clients,
      isContactModalOpen,
      selectedClientId,
      selectedQuotationId,
      message,
      prId,
      iid,
      clientSearchQuery,
      quotationSearchQuery,
    } = this.state;

    if (!isContactModalOpen) {
      return null;
    }

    const selectedClient = clients[selectedClientId] || {};

    // Filter clients based on search query
    const filteredClients = Object.entries(clients).filter(
      ([_, client]) =>
        client.clientName
          .toLowerCase()
          .includes(clientSearchQuery?.toLowerCase() || "") ||
        client.instituteName
          ?.toLowerCase()
          .includes(clientSearchQuery?.toLowerCase() || "")
    );

    // Filter quotations based on search query
    const filteredQuotations =
      selectedClient.quotations &&
      Object.entries(selectedClient.quotations).filter(
        ([_, quotation]) =>
          quotation.prName
            ?.toLowerCase()
            .includes(quotationSearchQuery?.toLowerCase() || "") ||
          quotation.quotationNumber
            ?.toLowerCase()
            .includes(quotationSearchQuery?.toLowerCase() || "")
      );

    return (
      <div className="modal-overlay">
        <div className="modal-content-contact">
          <div className="modal-header">
         <p>Contacts</p>
            <div onClick={() => this.setState({ isContactModalOpen: false })} style={{cursor:'pointer'}}>
              <FontAwesomeIcon icon={faTimes} size="lg"></FontAwesomeIcon>
            </div>
          </div>
          <div className="contacts">
            {/* Column for Clients */}
            <div className="column">
              <p>Clients</p>
              <input
                type="text"
                placeholder="Search clients..."
                value={clientSearchQuery || ""}
                style={{ border: "1px solid #cccc" }}
                onChange={(e) =>
                  this.setState({ clientSearchQuery: e.target.value })
                }
              />
              <div className="quotations-container" style={{ overflow: "auto" }}>
                {filteredClients && filteredClients.length > 0 ? (
                  filteredClients.map(([clientId, client]) => (
                    <div
                      key={clientId}
                      className={`client-item ${
                        selectedClientId === clientId ? "active" : ""
                      }`}
                      onClick={() => this.handleClientClick(clientId, client.iid, client.clientName)}
                    >
                      {client.clientName}
                      <p style={{ fontSize: "10px", color: "#605b5b" }}>
                        {client.instituteName}
                      </p>
                    </div>
                  ))
                ) : (
                  <div style={{ padding: "1rem", color: "#888" }}>
                    No contacts found.
                  </div>
                )}
              </div>
            </div>
            {/* Column for Quotations */}
            <div className="column">
                <p>Quotations</p>
                <input
                  type="text"
                  placeholder="Search quotations..."
                  style={{ border: "1px solid #cccc" }}
                  value={quotationSearchQuery || ""}
                  onChange={(e) =>
                    this.setState({ quotationSearchQuery: e.target.value })
                  }
                />
                <div className="quotations-container" style={{ overflow: "auto" }}>
                  {selectedClient?.quotations ? (
                    filteredQuotations && filteredQuotations.length > 0 ? (
                      filteredQuotations.map(([quotationId, quotation]) => (
                        <div
                          key={quotationId}
                          className={`quotation-item ${
                            selectedQuotationId === quotationId ? "active" : ""
                          }`}
                          onClick={() =>
                            this.handleQuotationClick(
                              quotationId,
                              quotation.quotationNumber,
                              quotation.prId
                            )
                          }
                        >
                          {quotation.quotationNumber || "-"}
                          <p style={{ fontSize: "10px", color: "#605b5b" }}>
                            {quotation.prName}
                          </p>
                        </div>
                      ))
                    ) : (
                      <div style={{ padding: "1rem", color: "#888" }}>
                        No records found.
                      </div>
                    )
                  ) : (
                    <div style={{ padding: "1rem", color: "#888" }}>
                      Please select faculty first.
                    </div>
                  )}
                </div>
              </div>

            {/* Column for Messages */}
            <div className="column message-column">
              {selectedQuotationId ? (
                <div>
                  <PurchaseRequestConversation
                    vendorId={config.instructorInfo.data.vendorId}
                    prId={prId}
                    prVendorId={selectedQuotationId}
                    iid={iid}
                    selectedClientName = {this.state.selectedClientName}
                  />
                </div>
              ) : (
                <p className="no-quotation">
                  Please select a Client and quotation first.
                </p>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }

  togglePopover = (
    userId,
    prVendorId,
    prId,
    iid,
    userName,
    instituteName,
    event
  ) => {
    const rect = event.currentTarget.getBoundingClientRect();
    const popoverWidth = 450;
    const popoverHeight = 580;
  

    let top = rect.bottom + window.scrollY + 10;
    let left = rect.left + window.scrollX;
  
  
    if (left + popoverWidth > window.innerWidth) {
      left = Math.max(8, window.innerWidth - popoverWidth - 9);
    }
  

    if (top + popoverHeight > window.innerHeight + window.scrollY) {
      top = rect.top + window.scrollY - popoverHeight - 10;
    }
  
    // Clamp top if still off-screen (like top screen edge)
    if (top < 9) {
      top = 9;
    }
  
    this.setState({
      isPopoverOpen: true,
      userId,
      prVendorId,
      prId,
      iid,
      userName,
      instituteName,
      popoverPosition: { top, left },
    });
  };

  closePopover = () => {
    this.setState({
      isPopoverOpen: false,
    });
    this.fetchMessages(this.state.prVendorId);
  };

 

  render() {
    const { messages } = this.state;

    return (
      <footer id="sticky-footer" className="footer">
        <div className="footer-container">
          <div className="tabs-container">
            <div className="tab-item" onClick={() => this.handleContactClick()} style={{background:'#ECF4FF', minHeight:'40px', fontWeight:'bolder'}}>
            <div>
            <img src={contact} />  Contacts
            </div>
            
            <FontAwesomeIcon icon={faChevronUp} size="lg" style={{ fontWeight:"lighter", width: '15px' }} />
            </div>
            {Object.keys(messages).length > 0 ? (
              Object.keys(messages).map((key) => (
                <div
                  className="tab-item"
                  key={messages[key].uniqueId}
                  onClick={(event) =>
                    this.togglePopover(
                      messages[key].vendorId,
                      messages[key].prVendorId,
                      messages[key].prId,
                      messages[key].iid,
                      messages[key].userName,
                      messages[key].instituteName,
                      event
                    )
                  }
                  title={messages[key].message}
                >
                 
                    <span
                      style={{
                        marginLeft: "5px",
                        padding: "0px",
                        cursor: "pointer",
                      }}
                    >
                    <b>{messages[key].userName}</b>{" "}
                  <p style={{ fontSize: "10px" }}>
                    {messages[key].instituteName}
                  </p>
                    </span>
                      
                      <FontAwesomeIcon icon={faTimes} size="lg" style={{ fontWeight:"lighter", width: '10px' }}  onClick={(e) => {
                        e.stopPropagation();
                        this.fetchMessages(messages[key].prVendorId);
                      }} />
                </div>
              ))
            ) : (
              <p className="no-messages">No new messages.</p>
            )}
          </div>
        </div>
    
        <PopoverWrapper
          isOpen={this.state.isPopoverOpen}
          position={this.state.popoverPosition}
          userName={this.state.userName}
          instituteName={this.state.instituteName}
          onClose={this.closePopover}
          userId={this.state.userId}
          prVendorId={this.state.prVendorId}
          prId={this.state.prId}
          iid={this.state.iid}
        />
        {this.contactModal()}
      </footer>
    );
  }
}

const mapStateToProps = (store) => ({
  iidArray: store.RouteMenuReducer.assignedIIDArray,
  iidDetails: store.RouteMenuReducer.assignedIIDDetails,
});

export default connect(mapStateToProps)(Footer);
